import Keycloak from 'keycloak-js';
const keycloak = Keycloak(JSON.parse(process.env.REACT_APP_KEYCLOAKCONFIG));

export default keycloak;